import { handleRemoveCommand } from './commands/grid_form_command_handler';
import { ApiUtil } from 'lecom-api';
import { FormEvents } from 'form/events/form_event_handler';

export default {
	execute,
};

function execute({ dataRows, dataRowId, dataRowIdField }, totalCount, commands, propsRows, gridPerPage, gridPage, gridFormName) {
	return new Promise((resolve, reject) => {
		const deletedDataRow = dataRows.find(currentDataRow => currentDataRow[dataRowIdField] === dataRowId);

		const subscribeEvent = new Promise((resolve, reject) => {							
			const gridFormFieldAPI = ApiUtil.getFieldAPI(gridFormName);										
			
			gridFormFieldAPI.publish(FormEvents.GRID_DELETE_BEFORE, deletedDataRow, dataRows, resolve, reject);		

			resolve();				
		});

		subscribeEvent
			.then(() => {																
				const updatedDataRows = dataRows.filter(currentDataRow => currentDataRow[dataRowIdField] !== dataRowId);
				const reCalcPage = Math.ceil((totalCount - 1) / gridPerPage);

				if (propsRows[dataRowId])
					delete propsRows[dataRowId];

				const result = {
					commands: handleRemoveCommand(commands, dataRowId),
					dataRows: updatedDataRows,
					totalCount: totalCount - 1,
					waitForAction: false,
					propsRows: propsRows,
					gridPage: (gridPage > reCalcPage && reCalcPage > 0) ? reCalcPage : gridPage
				};

				resolve({ result, deletedDataRow });
			})
			.catch(err => {
				reject(err);
			});		
	});
}
